import { createSlice } from '@reduxjs/toolkit';
import toggleTools from '@custom/rtk-apis/ToolToogle';

const toolButtonToggleSlice = createSlice({
  name: 'toolButtonToggleSlice',
  initialState: {
    loading: false,
    error: '',
    status: '',
    buttons: {
      MeasurementTools: true,
      Zoom: true,
      WindowLevel: true,
      Pan: true,
      TrackballRotate: true,
      Capture: true,
      Layout: true,
      AnnotationPreferences: true,
      Crosshairs: true,
      MoreTools: true,

      Length: true,
      Bidirectional: true,
      ArrowAnnotate: true,
      EllipticalROI: true,
      RectangleROI: true,
      CircleROI: true,
      PlanarFreehandROI: true,
      SplineROI: true,
      LivewireContour: true,

      Reset: true,
      'rotate-right': true,
      flipHorizontal: true,
      ImageSliceSync: true,
      ReferenceLines: true,
      ImageOverlayViewer: true,
      StackScroll: true,
      invert: true,
      Probe: true,
      Cine: true,
      Angle: true,
      CobbAngle: true,
      Magnify: true,
      CalibrationLine: true,
      TagBrowser: true,
      AdvancedMagnify: true,
      UltrasoundDirectionalTool: true,
      WindowLevelRegion: true,
      toggleOverlay: true,
      copyToClipboard: true,
    },
    overlay: {
      StudyPatientName: true,
      PatientId: true,
      PatientBirthDate: true,
      PatientSex: true,
      StudyID: true,
      StudyDate: true,

      ZoomLevel: true,
      InstanceNumber: true,
      WindowLevelOverlay: true,
    }
  },
  reducers: {
    toggleButton: (state, action) => {
      const buttonName = action.payload;
      state.buttons[buttonName] = !state.buttons[buttonName]; // Toggles the state of the specified button
    },
    setButtonState: (state, action) => {
      const { buttonName, value } = action.payload;
      state.buttons[buttonName] = value; // Directly sets the state of the specified button
    },
    toggleOverlay: (state, action) => {
      const overlayName = action.payload;
      state.overlay[overlayName] = !state.overlay[overlayName];
    },
    setOverlayState: (state, action) => {
      const { overlayName, value } = action.payload;
      state.overlay[overlayName] = value;
    },
    clearLoading: (state) => {
      state.loading = false;
      state.error = null;
      state.status = '';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(toggleTools.pending, (state, action) => {
      state.loading = true;
      state.error = null;
      state.status = 'pending';
    }),
    builder.addCase(toggleTools.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.status = 'success';
      // Merge response with current state
      state.buttons = {
        ...state.buttons,
        ...action.payload,
      };
    }),
    builder.addCase(toggleTools.rejected, (state, action) => {
      state.loading = false;
      state.status = 'failed';
      state.error = action.payload as string || 'Something went wrong';
    });
  },
});

export const { toggleButton, setButtonState, clearLoading, setOverlayState, toggleOverlay } = toolButtonToggleSlice.actions;

export default toolButtonToggleSlice.reducer;
